import { AxiosInstance } from "axios";
export default (httpClient: AxiosInstance) => ({
    login: async (pLogin: { usuario: string, senha: string }) => {
        const response = await httpClient.post(`/Login?login=${pLogin.usuario}&senha=${pLogin.senha}`);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    ListarPorId: async (pId: 0) => {
        const response = await httpClient.get(`/Login/id?id=${pId}`);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    }
});